import { FormikErrors } from 'formik'
import { GridRowId } from '@mui/x-data-grid-pro'
import { BulkUpdateStatusInput, BulkUpdateStatusDTO } from '../../typings'
import { bulkActionErrors } from '../../constants'
import { ISalesFunnelStage } from '@user/store/salesFunnel/typings'
import { BulkUpdateStatusFormModel } from './typings'

export function normalize(
  selectedRows: GridRowId[],
  values: BulkUpdateStatusFormModel,
): BulkUpdateStatusInput {
  const { salesFunnelId, salesFunnelStageId, closedReason, customReason } =
    values
  const ids = selectedRows.map((id) => Number(id))

  return {
    ids,
    salesFunnelId: Number(salesFunnelId),
    salesFunnelStageId: Number(salesFunnelStageId),
    reasonId: Number(closedReason),
    customReason,
  }
}

export function validateForm(
  values: BulkUpdateStatusFormModel,
  salesFunnelStages: ISalesFunnelStage[],
): FormikErrors<BulkUpdateStatusFormModel> {
  const errors: FormikErrors<BulkUpdateStatusFormModel> = {}

  if (values.salesFunnelId === '') {
    errors.salesFunnelId = 'Required'
  }

  if (values.salesFunnelStageId === '') {
    errors.salesFunnelStageId = 'Required'
  } else {
    const { name, closed } = salesFunnelStages.find(
      (x) => x.id === Number(values.salesFunnelStageId),
    )!

    const requireReason = closed && name !== 'Closed/Won'
    if (requireReason && values.closedReason === '') {
      errors.closedReason = 'Required'
    } else if (requireReason && values.closedReason === '0') {
      if (values.customReason === '') {
        errors.customReason = 'Required'
      }
    }
  }

  return errors
}

export function formatErrors(dto?: BulkUpdateStatusDTO) {
  const errors = new Map<GridRowId, string[]>()

  if (!!dto) {
    const { alreadyClosedEntities, nonClosureEntities } = dto

    const closed = alreadyClosedEntities === null ? [] : alreadyClosedEntities

    const hasAlreadyClosed = closed.length > 0

    closed.map((e) => {
      errors.set(e.entityId, [bulkActionErrors.updateStatus.closed.rowError])
    })

    const unmetReqs =
      nonClosureEntities === null
        ? []
        : nonClosureEntities.filter(
            (e) =>
              e.closingRequirements !== null && !e.closingRequirements.closable,
          )

    const hasUnmetReqs = unmetReqs.length > 0

    unmetReqs.map((e) => {
      const existing = errors[e.entityId] ?? []
      errors.set(e.entityId, [
        ...existing,
        bulkActionErrors.updateStatus.requirements.rowError,
      ])
    })

    return {
      errors,
      hasAlreadyClosed,
      hasUnmetReqs,
    }
  }

  return {
    errors,
    hasAlreadyClosed: false,
    hasUnmetReqs: false,
  }
}
